import {
	SET_TOKENS,
	SET_USER,
	UPDATE_AUTHENTICATED,
	UPDATE_VALIDATING,
	CLEAR_TOKENS,
	CLEAR_USER,
	DESTROY_AUTH,
	CHANGE_DEFAULT_DEPARTMENT,
	CHANGE_SHIPPING_RULES_STATUS,
	SET_CURRENTLY_SELECTING_DEPARTMENT_ID,
	SET_MFA_STATUS,
	SET_MFA_CHALLENGE_CONTEXT
} from './mutation-types'

import { Tokens } from '@models/Tokens'
import { User } from '@models/User'
import { createDefaultMfaState, createDefaultMfaChallenge } from './state'
// Remove this import - we don't need it anymore
// import app from '@/main'

export default {
	[UPDATE_AUTHENTICATED] (state, status) {
		state.authenticated = status
	},

	[UPDATE_VALIDATING] (state, status) {
		state.isValidating = status
	},

	[SET_TOKENS] (state, tokens) {
		localStorage.setItem(process.env.VUE_APP_ACCESS_TOKEN_NAME, tokens.accessToken)
		localStorage.setItem(process.env.VUE_APP_ID_TOKEN_NAME, tokens.idToken)
		localStorage.setItem(process.env.VUE_APP_REFRESH_TOKEN_NAME, tokens.refreshToken)
		state.tokens = tokens
	},

	[SET_USER] (state, user) {
		state.user = user
	},

	[CLEAR_TOKENS] (state) {
		localStorage.removeItem(process.env.VUE_APP_ACCESS_TOKEN_NAME)
		localStorage.removeItem(process.env.VUE_APP_ID_TOKEN_NAME)
		localStorage.removeItem(process.env.VUE_APP_REFRESH_TOKEN_NAME)
		state.tokens = new Tokens()
	},

	[CLEAR_USER] (state) {
		state.user = new User()
	},

	[DESTROY_AUTH] (state) {
		localStorage.removeItem(process.env.VUE_APP_ACCESS_TOKEN_NAME)
		localStorage.removeItem(process.env.VUE_APP_ID_TOKEN_NAME)
		localStorage.removeItem(process.env.VUE_APP_REFRESH_TOKEN_NAME)
		state.tokens = new Tokens()
		state.user = new User()
		state.authenticated = false
		state.mfa = createDefaultMfaState()
		state.mfaChallenge = createDefaultMfaChallenge()
	},

	[SET_MFA_STATUS] (state, status) {
		state.mfa = { ...createDefaultMfaState(), ...(status || {}), fetched: true }
	},

	[SET_MFA_CHALLENGE_CONTEXT] (state, context) {
		state.mfaChallenge = {
			sessionKey: context?.sessionKey || null,
			email: context?.email || null
		}
	},

	[SET_CURRENTLY_SELECTING_DEPARTMENT_ID] (state, id) {
		state.selectingDepartmentId = id
	},

	// Made this synchronous - only updates state
	[CHANGE_DEFAULT_DEPARTMENT] (state, { selectedDepartment, selectedCompany }) {
		state.user.selectedDepartmentId = selectedDepartment
		state.user.selectedCompanyId = selectedCompany
	},

	[CHANGE_SHIPPING_RULES_STATUS] (state, status) {
		state.user.shippingRulesAccepted = status
	}
}
